import packageMeta from '../../package.json';
import { getEnvData } from './aem';
import type { PageEnvironmentVariables } from '@seamless/one-context';

let envData: PageEnvironmentVariables | null = null;

async function fetchEnvData() {
  envData = (await getEnvData()).pageEnvironmentVariables;
}

fetchEnvData();

let getTrackingDispatchers: (() => Promise<any>) | null = null;
let TrackingEvent: any = null;

const importTrackingModule = async () => {
  if (!envData || envData.stage !== 'PROD') return;

  try {
    const module = await import('@owc/connection-aem-tracking');
    getTrackingDispatchers = module.getTrackingDispatchers;
    TrackingEvent = module.TrackingEvent;
  } catch (error) {
    console.error('Failed to load @owc/connection-aem-tracking:', error);
  }
};

// Load tracking module in production after envData is fetched
fetchEnvData().then(importTrackingModule);

export const pushDataLayerEvent = async (eventDetail: Record<string, any>) => {
  if (!envData || envData.stage !== 'PROD') {
    console.warn('Tracking is disabled in this environment.');
    return;
  }

  if (!getTrackingDispatchers) {
    console.error('Tracking module not yet loaded.');
    return;
  }

  const dataLayerEvent = {
    event: 'click',
    eventDetail,
    application: {
      id: 'cvans',
      version: packageMeta.version,
      businessUnit: 'b2b',
    },
  } as typeof TrackingEvent;

  window.dataLayer_ow = window.dataLayer_ow || [];
  try {
    const dispatchers = await getTrackingDispatchers();
    dispatchers.pushTrackingEvent(dataLayerEvent);

    if (
      !window.dataLayer_ow.some(
        (event) => JSON.stringify(event) === JSON.stringify(dataLayerEvent),
      )
    ) {
      window.dataLayer_ow.push(dataLayerEvent);
    }

    console.log('dataLayer_ow', window.dataLayer_ow);
  } catch (error) {
    console.error('Failed to push tracking event:', error);
  }
};
